import React from 'react';
import { FormGroup, Label, Input, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import style from './AdvancedSearch.module.scss';

const AdvancedSearch = ({
  open,
  onChange,
  onSearch,
  toggleAdvancedSearch,
  fromDate,
  toDate,
  isSearching,
}) => (open
  ? (
    <FormGroup className={style.advanced}>
      <Label>Date range</Label>
      <div className={style.inputs}>
        <Input
          type="date"
          value={fromDate}
          placeholder="From"
          onChange={
            (e) => onChange('fromDate', e.target.value)
          }
          required
        />
        <div style={{ width: "15px" }} />
        <Input
          type="date"
          value={toDate}
          placeholder="To"
          onChange={
            (e) => onChange('toDate', e.target.value)
          }
        />
      </div>
      <Button
        type="button"
        color="primary"
        onClick={onSearch}
        disabled={isSearching}
      >
        Search
      </Button>
      <Button
        type="button"
        color="primary"
        style={{ marginLeft: '5px' }}
        onClick={toggleAdvancedSearch}
      >
        Hide<i className="fa fa-caret-up"/>
      </Button>
    </FormGroup>
  ) : null
);

AdvancedSearch.propTypes = {
  open: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  toggleAdvancedSearch: PropTypes.func.isRequired,
  fromDate: PropTypes.string.isRequired,
  toDate: PropTypes.string.isRequired,
};

export default AdvancedSearch;
